/**
 * Разбор десятичных строк бэка (`"1000.000"`, `"90.00"`).
 *
 * Деньги складываем в копейках целыми числами: сумма десятка `parseFloat`
 * набирает погрешность, и итог себестоимости разъезжается с суммой строк на
 * копейку-другую — в чеке это выглядит как ошибка расчёта.
 */
export const parseDecimal = (
  value: string | null | undefined
): number | null => {
  if (value === null || value === undefined || value === '') return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

/** Рубли → копейки. Единица хранения всех сумм внутри расчёта. */
export const toKopecks = (rub: number): number => Math.round(rub * 100)

export const fromKopecks = (kopecks: number): number => kopecks / 100

/** Рубли с копейками и без «-0». Копейки скрываем, когда их нет. */
export const formatRub = (kopecks: number): string => {
  const safe = Object.is(kopecks, -0) ? 0 : kopecks
  return `${fromKopecks(safe).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} ₽`
}

/**
 * Количество продукта: три знака после запятой, как отдаёт бэк, но хвост из
 * нулей не показываем — «150.500 мл» читается хуже, чем «150,5 мл».
 */
export const formatAmount = (amount: number): string =>
  amount.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })

/**
 * Разумный потолок для полей ввода. Без него `toFixed` на больших числах
 * отдаёт экспоненциальную запись («1e+21»), которую decimal-поле не примет, а
 * человек видит только «не удалось сохранить».
 */
export const MAX_INPUT_VALUE = 1_000_000

/**
 * Количество для отправки на бэк. Точку, а не запятую, и без пробелов: поле
 * decimal, локализованная строка не пройдёт валидацию.
 */
export const toDecimalString = (value: number, fraction: number): string =>
  value.toFixed(fraction)

/** Число из поля ввода: запятая тоже десятичный разделитель. */
export const parseInput = (raw: string): number | null => {
  const normalized = raw.trim().replace(',', '.')
  if (normalized === '') return null
  const value = Number(normalized)
  return Number.isFinite(value) ? value : null
}
